export const X_AXIS_PADDING = 0.5;
export const BAR_CHART_MARGIN = { top: 20, right: 20, bottom: 40, left: 40 };
export const TOOLTIP_OFFSET = { top: -30, left: 35 };
export const Y_AXIS_LABEL_OFFSET = 24;
